const countdown = () => {
    const countDate = new Date('October 14, 2023 09:00:00').getTime();
    const now = new Date().getTime();
    const gap = countDate - now;

    // How the heck does time work?
    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    const day = hour * 24;

    // Maths!

    const textDay = Math.floor(gap / day);
    const textHour = Math.floor((gap % day) / hour);
    const textMinute = Math.floor((gap % hour) / minute);
    const textSecond = Math.floor((gap % minute) / second);

    //HTML
    document.querySelector('.day').innerText = textDay;
    document.querySelector('.hour').innerText = textHour;
    document.querySelector('.minute').innerText = textMinute;
    document.querySelector('.seconds').innerText = textSecond;

    if(gap < 10000)
    {
        document.querySelector('.countdown').innerText = 'Happy Run Day!'
    }


}
function init () {
    setInterval(countdown, 1000);
}
export default {
    init
  };


// WEBPACK FOOTER //
// ./src/js/vanilla/countdown.min.js